<template>
  <TableLineWrapper :isBottomBorderNotShow="index === rowLength - 1">
    <!-- Order ID skeleton -->
    <TableInfoLine>
      <v-skeleton-loader type="text" width="80" class="mt-1" />
    </TableInfoLine>

    <!-- Send date skeleton -->
    <TableInfoLine>
      <v-skeleton-loader type="text" width="100" class="mt-1" />
    </TableInfoLine>

    <!-- Due date skeleton -->
    <TableInfoLine>
      <v-skeleton-loader type="text" width="100" class="mt-1" />
    </TableInfoLine>

    <!-- Reference skeleton -->
    <TableInfoLine v-if="mode === 'orders'">
      <v-skeleton-loader type="text" width="100" class="mt-1" />
    </TableInfoLine>

    <!-- Status skeleton -->
    <TableInfoLine>
      <v-skeleton-loader type="chip" width="90" class="mt-1" />
    </TableInfoLine>

    <!-- Amount skeleton -->
    <TableInfoLine>
      <v-skeleton-loader type="text" width="100" class="mt-1" />
    </TableInfoLine>

    <!-- Actions skeleton -->
    <TableInfoLine>
      <v-skeleton-loader
        type="button"
        :width="actionColumnWidth"
        class="mt-1"
      />
    </TableInfoLine>
  </TableLineWrapper>
</template>

<script>
import TableInfoLine from "./TableInfoLine.vue";
import TableLineWrapper from "./TableLineWrapper.vue";

export default {
  name: "TableSkeletonLoader",
  components: {
    TableInfoLine,
    TableLineWrapper,
  },
  props: {
    mode: {
      type: String,
    },
    rowLength: {
      type: Number,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    actionColumnWidth: {
      type: String,
    },
  },
};
</script>

<style scoped lang="scss">
:deep(.v-skeleton-loader__text),
:deep(.v-skeleton-loader__chip),
:deep(.v-skeleton-loader__button) {
  margin: 0;
}
</style>
